/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Footer } from '@g17eco/molecules/footer';
import Logo from '../../images/logo.svg';
import { TermsOfUse } from './TermsOfUse';
import { PrivacyPolicy } from './PrivacyPolicy'
import { TermsAndConditions } from './TermsAndConditions';
import { ApolloProvider } from '@apollo/client';
import GraphQlClient from '../../services/graphql/GraphQlClient';
import queryString from 'query-string';

import './help.scss';
import { SEO } from '../../apps/common/components/SEO';

const getBody = (type: any) => {
  switch (type) {
    case 'acceptable-use-policy':
    case 'terms':
      return <ApolloProvider client={GraphQlClient}>
        <TermsOfUse />
      </ApolloProvider>
    case 'privacy-policy':
      return <ApolloProvider client={GraphQlClient}>
        <PrivacyPolicy />
      </ApolloProvider>
    case 'terms-and-conditions':
      return <ApolloProvider client={GraphQlClient}>
        <TermsAndConditions />
      </ApolloProvider>
    default:
      return '';
  }

}

const Legal = ({ match }: any) => {

  const history = useHistory();
  const params = queryString.parse(history.location.search);

  const returnUrl = String(params.returnUrl);
  const url = returnUrl && returnUrl.startsWith('/') ? returnUrl : '/';
  const breadcrumbTitle = params.breadcrumbTitle ? String(params.breadcrumbTitle).replace(/[^a-zA-Z0-9\s]/g, '-') : 'Go back to home page';

  return (
    <div className='legalWrapper'>
      <SEO />
      <div className='legalContainer'>
        <header>
          <img className='logo' src={Logo} alt='G17Eco' />
        </header>

        <div className='legalBodyContainer'>
          <div><Link to={url}><i className='fa fa-home mr-2' />{breadcrumbTitle}</Link></div>
          {getBody(match.params.type)}
        </div>
        <Footer />
      </div>
    </div>
  )
}

export default Legal;
